import { detect } from "detect-browser";

export function IsSupportedBrowser (): boolean {
    let browser = detect();
    if ( browser == null ) {
        return true;
    }

    switch ( browser.name ) {
        case "chrome":
        case "safari":
        case "firefox":
        case "edge":
        case "opera":
    //    case "vivaldi":
        case "ios":
        case "samsung":
        case "crios":
        case "fxios":
        case "ios-webview":
        case "chromium-webview":
        case "edge-chromium":
            return true;
        default:
            
            alert( "Your browser is not supported: " + browser.name );
            return false;
    }
}